import React from 'react';
import {useFontSizeStore} from "../stores/useFontSizeStore";
import Image1 from "../assets/doziranje_300.jpeg";

const Automation6 = () => {

  const options = useFontSizeStore(state => state.defs)
  const textSizeSelected = useFontSizeStore(state => state.textSizeSelected)
  const langSelected = useFontSizeStore((state) => state.lang)
  return (
    <>

      <img src={Image1} className="ml-auto mr-auto" style={{display: 'block', width: '80%'}} alt="Auto" />
      <div className="container">
        <div className="row">
          <div className="col-12">
            <p style={options[textSizeSelected].styleHead}>{langSelected === 0 ? 'PRIPREMA I DOZIRANJE DISPERZIJE PIGMENATA' : 'PREPARATION AND DOSING OF PIGMENT DISPERSION'}</p>
          </div>
        </div>

        <div className="row mt-1">
          <div className="col-12">
            <p style={options[textSizeSelected].styleNormal}>{langSelected === 0 ? 'Prikazan software upravlja automatikom miješanja i doziranja 5 različitih tekućih pigmenata. Postoje rješenja trenutno do maksimalno 8 tekućih pigmenta ili 4 tekuća pigmenta na 2 betonare na 1 vagi.' : 'The presented software manages the automatic mixing and dosing of 5 different liquid pigments. We currently offer a solution for mixing up to 8 liquid pigments or 4 liquid pigments at 2 concrete plants with 1 scale.'}</p>
          </div>
        </div>

      </div>
    </>
  );
};

export default Automation6;
